import type {PredictionResult} from "modules/enums";
import type {ILoadMoreAction, TLoadMoreResponse} from "modules/types";
import {createAction} from "redux-act";

export const fetchLeaders = createAction<ILoadMoreAction>();

interface ILeader {
	userId: number;
	username: string;
	levelColor: string;
	avatar: null | string;
	roundId: number;
	streak: number | null;
	rank: number;
	result: PredictionResult | null;
	predictions: IPrediction[];
}

interface IPrediction {
	number: number;
	unitId: number;
	playerId: number;
	result: PredictionResult | null;
}

export const fetchLeadersSuccess = createAction<TLoadMoreResponse<{leaders: ILeader[]}>>();
export const fetchLeadersFailed = createAction();
